import { render, staticRenderFns } from "./PopularTv.vue?vue&type=template&id=b7b53638"
import script from "./PopularTv.vue?vue&type=script&lang=js"
export * from "./PopularTv.vue?vue&type=script&lang=js"
import style0 from "./PopularTv.vue?vue&type=style&index=0&id=b7b53638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports